import { Link } from "react-router-dom";

const backend = [
    {
        id: 1,
        image:'',
        title: "Rate Limiter",
        Desc: "A rate limiting system implements sliding window counter algorithms with Redis sorted sets for precise traffic control, dual-layer caching with in-memory fallback, asynchronous queue-based processing for optimal system performance, and real-time monitoring with RFC-compliant headers and administrative dashboards.",
        stack: "NodeJS, Redis, System Design",
        Github: "https://github.com/sanikaardekar/rate-limiter",
        Link:"none",
        Mentions: 'Practise Project'
    },
]
export default backend;